module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"title":"Nossos destaques","description":"Veja alguns dos nossos produtos em destaque","action":"Ver Detalhes"},"en":{"title":"Our highlights","description":"Here are some of our main products","action":"See Details"},"es":{"title":"Nuestros destaques","description":"Vea algunos de nuestros productos en destaque","action":"Ver Detalles"}}')
  delete Component.options._Ctor
}
